module.exports = __webpack_public_path__ + "img/Gogi Gvakharia.a362183d.png";